import { symbol } from '../../Equivalence/dist/effect-Equivalence.esm.js';
import { isSymbol as isSymbol$1 } from '../../Predicate/dist/effect-Predicate.esm.js';

/**
 * @since 2.0.0
 */

/**
 * Tests if a value is a `symbol`.
 *
 * @param input - The value to test.
 *
 * @example
 * import { isSymbol } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isSymbol(Symbol.for("a")), true)
 * assert.deepStrictEqual(isSymbol("a"), false)
 *
 * @category guards
 * @since 2.0.0
 */
const isSymbol = isSymbol$1;

/**
 * @category instances
 * @since 2.0.0
 */
const Equivalence = symbol;

export { Equivalence, isSymbol };
